import React, { useState, useEffect } from "react";
import Header1 from "../../../Components/seperate Components/Header1";
import { faCalendarDay, faMessage } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "../../../Components/Footer";
import Reply from "../../../Components/seperate Components/Reply";
import RecentPost from "../../../Components/seperate Components/RecentPost";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import "../../../Styles/Redirecting Styles/FooterStyle/BlogDetails.css";
// import img1 from "../../../assets/All Images/e-commerce-website.avif";
// import img1 from "../../../assets/All Images/hire-destintion.jpg";
import { Helmet } from "react-helmet";

const BlogDetails = () => {
  const { permalink } = useParams();
  const [comments, setComments] = useState([]);

  const fetchComments = async () => {
    try {
      const { data } = await axios.get(
        `https://mars.zithas.com/api/comment_reply/${permalink}`
      );
      setComments(data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchComments();
  }, [permalink]);

  const [post, SetPost] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get(
          `https://mars.zithas.com/api/blog/${permalink}`
        );
        SetPost(data);

        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
    fetch();
  }, [permalink]);

  return (
    <div>
      <Helmet>
        <title>Top WordPress Plugins for E-commerce Websites in 2025</title>
        <meta
          name="description"
          content="Top WordPress Plugins for E-commerce Websites in 2025"
        />
      </Helmet>

      {/* Header section */}
      <Header1 />
      <div
        className="bd-page-title-area bd-page-title-bg_blog blogdetail_responsive-ban pt-180 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bd-page-title text-center z-index">
                <h2 className="breadcrumb-title1 blogdetail-main-tittle">
                  Top WordPress Plugins for E-Commerce Websites in 2024
                </h2>
                <div className="breadcrumb-menu">
                  <div className="bd-blog-meta mb-15">
                    <ul>
                      <li>
                        <a href="">
                          <i>
                            <FontAwesomeIcon icon={faCalendarDay} />
                          </i>
                          Feb 13, 2024
                        </a>
                      </li>
                      <li>
                        <a href="">
                          <i>
                            <FontAwesomeIcon icon={faMessage} />
                          </i>
                          0 Comments
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Blogs section */}
      <section className="bd-blog-deatils-area pt-105 pb-100">
        <div className="container " style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-lg-8 Blog-responsive-Section1">
              <div className="blog__details--wrapper mr-50 mb-50">
                <div className="ablog__img mb-50">
                  <img
                    // src={img1}
                    alt="blog image not found"
                    // style={{ width: "410px", height: "250px" }}
                  />
                </div>
                <p>
                  Highlight the advantages of hiring resources in Singapore,
                  such as its strong economy, skilled workforce, and strategic
                  location in Southeast Asia.
                  <br />
                  <br />
                  <b>Highly Skilled Workforce:</b> Discuss Singapore's education
                  system and its focus on skill development, making it home to
                  highly trained professionals.
                  <br />
                  <br />
                  <b>Strong Legal Framework:</b> Emphasize Singapore's robust
                  labor laws, which make hiring resources seamless and legally
                  secure.
                  <br />
                  <br />
                  <b>Diverse Talent Pool:</b> Showcase the multicultural aspect
                  of Singapore, which allows companies to tap into diverse
                  talents from across the globe.
                  <br />
                  <br />
                  <b>Tax Incentives for Businesses:</b> Mention Singapore’s
                  tax-friendly policies that benefit businesses looking to hire
                  resources locally.
                  <br />
                  <br />
                  Sum up the reasons why businesses should consider hiring in
                  Singapore to boost their productivity and growth.
                  {/* <br />
                  <br />{" "} */}
                </p>
                {/* <Reply posts={post} comments={comments} /> */}
              </div>
            </div>
            <RecentPost />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogDetails;
